import React from 'react';
import MessageContainer from './MessageContainer';

interface ErrorDisplayProps {
  error: string;
  onBack: () => void;
}

// Simple error icon component
const ErrorIcon: React.FC = () => (
  <div className="text-red-600 mb-4">
    <svg className="mx-auto h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
    </svg>
  </div>
);

// Simple error message component
const ErrorMessage: React.FC<{ error: string }> = ({ error }) => (
  <>
    <h2 className="text-xl font-semibold text-gray-900 mb-2">{error}</h2>
    <p className="text-gray-600 mb-4">The prompt you're looking for might have been removed or doesn't exist.</p>
  </>
);

// Simple action button component
const ActionButton: React.FC<{ onClick: () => void; children: React.ReactNode }> = ({ onClick, children }) => (
  <button
    onClick={onClick}
    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-brand-dark-blue hover:bg-brand-electric-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-electric-blue"
  >
    {children}
  </button>
);

// Container component that composes the simple components
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onBack }) => (
  <MessageContainer>
    <ErrorIcon />
    <ErrorMessage error={error} />
    <ActionButton onClick={onBack}>Go Back</ActionButton>
  </MessageContainer>
);

export default ErrorDisplay;

// Export individual components for reuse
export { ErrorIcon, ErrorMessage, ActionButton };
